export default __webpack_public_path__ + "static/graph-912d7650f3365663f166e92da5767d09.svg";